export default __webpack_public_path__ + "static/media/dizzystonerooster3draft_c7ec309a2e972ea845aefaac9d3b5242.d2af8234.png";